// Auto-generated by scripts/generate-registry.mjs from packages/modules/solara_ambient_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const solara_ambient_lamp: ModuleSchema = {
  "id": "solara_ambient_lamp",
  "uniqueId": "B3D_HWY13",
  "createdAt": "2026-10-04T07:54:20.670Z",
  "updatedAt": "2026-10-11T14:15:16.394Z",
  "label": "Solara Fluted",
  "description": "Parametric Japanese fluted ambient table lamp reconstructed 1:1 from 3MF reference",
  "category": "lighting",
  "tags": [
    "lamp",
    "solara",
    "fluted",
    "ribbed",
    "japanese",
    "ambient",
    "shade"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Base Outer Diameter (Rib Tips)",
      "min": 80,
      "max": 140,
      "step": 1,
      "default": 80,
      "unit": "mm"
    },
    {
      "key": "baseCoreDia",
      "label": "Base Inner Core Diameter (Trough)",
      "min": 35,
      "max": 80,
      "step": 1,
      "default": 52,
      "unit": "mm"
    },
    {
      "key": "baseHeight",
      "label": "Base Column Height",
      "min": 40,
      "max": 160,
      "step": 1,
      "default": 70,
      "unit": "mm"
    },
    {
      "key": "baseRibCount",
      "label": "Base Flutes Count (Ribs)",
      "min": 20,
      "max": 80,
      "step": 2,
      "default": 44,
      "unit": "ribs"
    },
    {
      "key": "shadeDia",
      "label": "Shade Outer Diameter (Rib Tips)",
      "min": 80,
      "max": 180,
      "step": 1,
      "default": 120,
      "unit": "mm"
    },
    {
      "key": "shadeCoreDia",
      "label": "Shade Inner Core Diameter (Trough)",
      "min": 70,
      "max": 170,
      "step": 1,
      "default": 114,
      "unit": "mm"
    },
    {
      "key": "shadeHeight",
      "label": "Shade Column Height",
      "min": 60,
      "max": 180,
      "step": 1,
      "default": 140,
      "unit": "mm"
    },
    {
      "key": "shadeRibCount",
      "label": "Shade Flutes Count (Ribs)",
      "min": 30,
      "max": 100,
      "step": 2,
      "default": 60,
      "unit": "ribs"
    },
    {
      "key": "wallThickness",
      "label": "Diffuser Wall Thickness",
      "min": 0.8,
      "max": 3,
      "step": 0.1,
      "default": 1,
      "unit": "mm"
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "solara_base",
      "label": "Fluted Lamp Base",
      "default": "#EAB308",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "solara_shade",
      "label": "Fluted Lampshade",
      "default": "#FACC15",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "base_screws",
      "label": "4x E27 Base Screws",
      "default": "#64748B",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "solara_base_obj",
      "label": "Fluted Lamp Base (44 Flutes)",
      "name": "Fluted Lamp Base (44 Flutes)",
      "color": "#EAB308",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "solara_base",
          "label": "Fluted Lamp Base",
          "name": "Fluted Lamp Base",
          "groupId": 0,
          "colorKey": "solara_base",
          "defaultColor": "#EAB308",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "solara_shade_obj",
      "label": "Fluted Lampshade (60 Flutes)",
      "name": "Fluted Lampshade (60 Flutes)",
      "color": "#FACC15",
      "assembled_z_offset": 0,
      "exploded_z_offset": 60,
      "parts": [
        {
          "id": "solara_shade",
          "label": "Fluted Lampshade",
          "name": "Fluted Lampshade",
          "groupId": 1,
          "colorKey": "solara_shade",
          "defaultColor": "#FACC15",
          "assembled_z_offset": 0,
          "exploded_z_offset": 60,
          "export_stl": true
        }
      ]
    },
    {
      "id": "solara_screws_obj",
      "label": "E27 Base Screws",
      "name": "E27 Base Screws",
      "color": "#64748B",
      "assembled_z_offset": 0,
      "exploded_z_offset": -15,
      "parts": [
        {
          "id": "base_screws",
          "label": "4x E27 Base Screws",
          "name": "4x E27 Base Screws",
          "groupId": 2,
          "colorKey": "base_screws",
          "defaultColor": "#64748B",
          "assembled_z_offset": 0,
          "exploded_z_offset": -15,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "assembly",
      "label": "Full Lamp Assembly",
      "targetGroupId": -1,
      "default": true
    },
    {
      "id": "base",
      "label": "Lamp Base Only",
      "targetGroupId": 0
    },
    {
      "id": "shade",
      "label": "Fluted Lampshade Only",
      "targetGroupId": 1
    }
  ]
};
